/** Collapsed width: icon rail (46px) + drawer `px: 2` padding (32px) with a small margin. */
export const SIDEBAR_DIMENSIONS = {
  EXPANDED_WIDTH: 260,
  COLLAPSED_WIDTH: 80,
  TOGGLE_SIZE: 32,
  ICON_CONTAINER_SIZE: 46,
  AVATAR_SIZE: 34
} as const;
